import React from 'react';
import { Check, Download, Share2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
interface FlightConfirmationScreenProps {
  onHome: () => void;
}
export function FlightConfirmationScreen({
  onHome
}: FlightConfirmationScreenProps) {
  return <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center" data-id="element-256">
      <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6 animate-bounce" data-id="element-257">
        <Check size={40} strokeWidth={3} data-id="element-258" />
      </div>

      <h1 className="text-2xl font-bold text-[#003366] mb-2" data-id="element-259">
        Réservation confirmée !
      </h1>
      <p className="text-gray-500 mb-8" data-id="element-260">
        Votre e-billet a été envoyé par email.
      </p>

      <Card className="w-full max-w-sm bg-gray-50 border-dashed border-2 border-gray-200 mb-8" data-id="element-261">
        <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-262">
          Référence de réservation
        </div>
        <div className="text-3xl font-mono font-bold text-[#003366] tracking-wider" data-id="element-263">
          ABC123X
        </div>
      </Card>

      <div className="w-full max-w-sm space-y-3" data-id="element-264">
        <Button fullWidth variant="primary" leftIcon={<Download size={18} data-id="element-266" />} data-id="element-265">
          Télécharger le e-billet
        </Button>
        <Button fullWidth variant="outline" leftIcon={<Share2 size={18} data-id="element-268" />} data-id="element-267">
          Partager via WhatsApp
        </Button>
        <Button fullWidth variant="ghost" onClick={onHome} data-id="element-269">
          Retour à l'accueil
        </Button>
      </div>
    </div>;
}